import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from './stores/authStore'
import Layout from './components/Layout'
import { LandingLayout } from './components/landing'
import Pipeline from './pages/Pipeline'
import Ledger from './pages/Ledger'
import Vault from './pages/Vault'
import Settings from './pages/Settings'
import Login from './pages/Login'
import { AutoApply, Home, HowItWorks, Privacy, Requirements, Terms } from './pages/landing'
import { ToastContainer, ErrorBoundary, FullPageLoading } from './components/ui'

export default function App() {
  const { isAuthenticated, isLoading, _hasHydrated } = useAuthStore()

  // Wait for persisted state to hydrate and session to restore
  if (!_hasHydrated || isLoading) {
    return <FullPageLoading />
  }

  if (!isAuthenticated) {
    return (
      <ErrorBoundary>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="*"
            element={
              <LandingLayout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/autoapply" element={<AutoApply />} />
                  <Route path="/how-it-works" element={<HowItWorks />} />
                  <Route path="/privacy" element={<Privacy />} />
                  <Route path="/requirements" element={<Requirements />} />
                  <Route path="/terms" element={<Terms />} />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </LandingLayout>
            }
          />
        </Routes>
        <ToastContainer />
      </ErrorBoundary>
    )
  }

  return (
    <ErrorBoundary>
      <Layout>
        <Routes>
          <Route path="/" element={<Navigate to="/pipeline" replace />} />
          <Route path="/pipeline" element={<Pipeline />} />
          <Route path="/ledger/*" element={<Ledger />} />
          <Route path="/vault" element={<Vault />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="*" element={<Navigate to="/pipeline" replace />} />
        </Routes>
      </Layout>
      <ToastContainer />
    </ErrorBoundary>
  )
}
